import { WebApi } from "./WebApi";
import { Command } from "./Command";
import { HttpMethod } from "./HttpMethod";
export class ApiWrapper {
    api;
    constructor(api) {
        this.api = api;
    }
    resolveUrl(path) {
        return WebApi.resolveUrl(path);
    }
    get(url) {
        return this.api.request(new Command(HttpMethod.Get, url));
    }
    post(url) {
        return this.api.request(new Command(HttpMethod.Post, url));
    }
    put(url) {
        return this.api.request(new Command(HttpMethod.Put, url));
    }
    patch(url) {
        return this.api.request(new Command(HttpMethod.Patch, url));
    }
    delete(url) {
        return this.api.request(new Command(HttpMethod.Delete, url));
    }
    async download(url, params = null, filename = null) {
        let result = await WebApi.download(url, params);
        filename = filename ?? result.params.filename;
        const data = result.data;
        let win = window;
        if (win.URL) {
            this.api.downloadForFirefox(filename, data);
        }
        else if (win.webkitURL) {
            this.api.downloadForChrome(filename, data);
        }
        else {
            console.error("not supported browser.");
            throw Error("ダウンロードに失敗しました。");
        }
    }
    async downloadByCommand(command, filename = null) {
        let request = WebApi.requestFactory.create(command);
        let result = await WebApi.downloadByConfig(request);
        filename = filename ?? result.params.filename;
        const data = result.data;
        let win = window;
        if (win.URL) {
            this.api.downloadForFirefox(filename, data);
        }
        else if (win.webkitURL) {
            this.api.downloadForChrome(filename, data);
        }
        else {
            console.error("not supported browser.");
            throw Error("ダウンロードに失敗しました。");
        }
    }
    async getFileBlob(command) {
        let request = WebApi.requestFactory.create(command);
        let result = await WebApi.getFileBlob(request);
        return result;
    }
    async getFileBlobAndFilename(command) {
        let request = WebApi.requestFactory.create(command);
        let result = await WebApi.getFileBlobAndFileName(request);
        return result;
    }
    get antiForgery() {
        return WebApi.antiForgery;
    }
}
export class ApiBase {
    api;
    constructor() {
        this.api = new ApiWrapper(this);
    }
    async request(command) {
        let request = WebApi.requestFactory.create(command);
        let result = await WebApi.request(request);
        if (!result) {
            return null;
        }
        return result.data;
    }
    async requestBlob(command) {
        const req = WebApi.requestFactory.create(command);
        const result = await WebApi.requestBlob({
            ...req,
            responseType: "blob"
        });
        if (!result) {
            throw new Error("Blob response is null");
        }
        return result.data;
    }
    downloadForFirefox(filename, data) {
        let a = document.createElement("a");
        a.download = filename;
        a.target = "_blank";
        a.href = window.URL.createObjectURL(data);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    downloadForChrome(filename, data) {
        let a = document.createElement("a");
        a.download = filename;
        a.target = "_blank";
        a.href = window.webkitURL.createObjectURL(data);
        a.click();
    }
}
